import { render, staticRenderFns } from "./ScadaAlarmsSettings.vue?vue&type=template&id=946239fa&"
import script from "./ScadaAlarmsSettings.vue?vue&type=script&lang=js&"
export * from "./ScadaAlarmsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports